var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#bfbfbf"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5V3h-2.002z",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    fontWeight: 400
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7v8h9v-1H3V6.333zm11.002-1L13 15h1V7z",
    fontFamily: "Ubuntu",
    fontSize: 15,
    letterSpacing: 0,
    textAnchor: "middle",
    wordSpacing: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.986a8.47 8.47 0 0 1 .607-.122c.253-.043.543-.064.872-.064.295 0 .54.043.735.129.195.08.35.197.465.35.119.147.202.326.25.535.047.21.071.44.071.693V14.2H8z",
    fontFamily: "Ubuntu",
    letterSpacing: 0,
    textAnchor: "end",
    wordSpacing: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 .293L.146 8.146l.708.708L8 1.707l7.146 7.147.708-.708z",
    fillRule: "evenodd",
    fontFamily: "sans-serif",
    overflow: "visible",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none"
    },
    "white-space": "normal"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ea19b867eafbc376621bb52dc6ff48c7.svg";
export { ForwardRef as ReactComponent };